module.exports = "mutation UpdateHotlineResult($data:HotlineResultInput!){updateHotlineResult(data:$data){success}}"